import React, { Component } from 'react';
import LinearGauge from './LinearGauge/LinearGauge';
import { Row, Col } from 'react-bootstrap';


export default class GaugeArea extends Component {
    render() {
        let min = 0;
        let max = 0;
        let ranges = undefined;
        let values = [0,0,0];
        let colors = undefined;

        if (this.props && this.props.data) {
            values = [];
            values.push(this.props.data.monthValue);
            values.push(this.props.data.threeMonthValue);
            values.push(this.props.data.sixMonthValue);

            colors = this.props.colors;
            min = this.props.data.min || 0;
            max = this.props.data.max || 0;
            ranges = this.props.data.ranges;
        }

        return (
            <div style={{marginBottom: "5px"}}>
                <Row>
                    <Col xs={12}>
                        <h5>{this.props.title}</h5>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <LinearGauge values={values} valueLabels={[1, 3, 6]} min={min} max={max} height={10} ranges={ranges} colors={colors} pointerSize={10} />
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/GaugeArea.jsx